import React from 'react';
import { Article, Numbers, Activities, Events, Leaders, Specialnews } from '../components';
import Button from '../components/button/button';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <>
      <Article />
      <Specialnews />
      <Numbers />
      <Leaders />
      <section className='volunteer-awards' style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          gap: "1.5rem", 
          marginBottom: "2rem",
          width: "100%",
          flexWrap: "wrap" /* Allows buttons to stack cleanly on smaller screens */
        }}>
        </div>
      </section>

      <Activities />
      <Events />
    </>
  );
};

export default Home;